import React from 'react';
import { useAuth } from '../../context/AuthContext';

const LogoutButton = () => {
    const { logout } = useAuth();

    const handleLogout = async () => {
        try {
            await logout();
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    return (
        <button
            className="logout-button"
            onClick={handleLogout}
            title="Log Out"
        >
            <span>Log Out</span>
        </button>
    );
};

export default LogoutButton;